import React, { createContext, useContext, useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import { matchPath, useLocation, useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { useToast } from "./ToastContext";
import { API_URL } from "../utils/const";
import axios from "axios";

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const { setToastObj } = useToast();
  const [notification, setNotification] = useState([]);
  const [totalRecord, setTotalRecord] = useState(0);
  const [roles, setRoles] = useState([]);
  const [authUser, setAuthUser] = useState(null);
  const [cookies, setCookie, removeCookie] = useCookies(["token"]);

  useEffect(() => {
    const reactToken = cookies.token;
    // getNotification();
    if (reactToken) {
      if (isTokenValid(reactToken)) {
        setAuthUser(jwtDecode(reactToken));
      } else {
        logout();
      }
    } else {
      if (
        location.pathname !== "/login" &&
        location.pathname !== "/password/reset" &&
        !matchPath("/confirm-password/:id", location.pathname) // Match dynamic path
      ) {
        logout();
      }
    }
  }, [location]);

  const getNotification = async () => {
    try {
      const result = await axios.post(`${API_URL}/notification`);
      const role = cookies.token;
      const decode = jwtDecode(role);
      setRoles(decode.roles);
      setNotification(result.data.data);
      setTotalRecord(result.data.totalRecord);
    } catch (error) {
      console.log(error);
    }
  };

  const isTokenValid = (reactToken) => {
    if (reactToken) {
      const decodedToken = jwtDecode(reactToken);
      const currentTime = Date.now() / 1000;
      return decodedToken.exp > currentTime;
    }
    return false;
  };

  const login = (token, roles) => {
    setCookie("token", token, { path: "/" });
    setCookie("userRoles", roles[0], { path: "/" });
    setAuthUser(jwtDecode(token));
    const lastPath = localStorage.getItem("lastPath");
    setToastObj({ msg: "Login Berhasil", type: "success" });
    navigate(
      lastPath && lastPath.startsWith("/")
        ? lastPath
        : "/akademik/course-sessions/all"
    );
    localStorage.removeItem("lastPath");
  };

  const logout = () => {
    removeCookie("token", { path: "/" });
    removeCookie("userRoles", { path: "/" });
    setAuthUser(null);
    setToastObj({ msg: "Logout Berhasil", type: "success" });
    navigate("/login");
    localStorage.removeItem("roles");
    // localStorage.setItem("lastPath", location.pathname);
  };

  const value = {
    authUser,
    setAuthUser,
    login,
    logout,
    notification,
    roles,
    totalRecord,
  };

  return (
    <AuthContext.Provider value={value}>{props.children}</AuthContext.Provider>
  );
}
